import React from "react";
import Icon from "../icons/Icon";
import Pill from "../ui/Pill";
import { classify, extractIssueId, issueUrl, typeLabel } from "../../domain/inconsistencies";
import { RULE_GROUP_META } from "../../domain/inconsistencyRules";

function OccurrenceItem({ item }) {
  const rule = classify(item);
  const group = rule ? RULE_GROUP_META[rule.group] : null;
  const url = issueUrl(item);
  const issueId = extractIssueId(item.description);
  const { details } = item;

  return (
    <div className="occ-item" data-testid="occurrence">
      <div className="occ-head">
        {group ? (
          <>
            <Pill variant={group.pill}>{group.itemLabel}</Pill>
            <Pill>{rule.statusLabel}</Pill>
          </>
        ) : (
          <Pill>{typeLabel(item.type)}</Pill>
        )}
      </div>

      <p className="occ-desc">{item.description}</p>

      {/* A mensagem do backend reafirma a descrição com outras palavras, então
          entra como nota subordinada e não como uma segunda alegação. */}
      {details && <p className="occ-note">{details.message}</p>}

      {(details || url) && (
        <div className="occ-foot">
          {details && (
            <p className="occ-owner">
              <span className="meta-label">Responsável</span>
              {details.assigned_to}
            </p>
          )}

          {/* Um link por ocorrência: a tela antiga decidia duas vezes no mesmo
              JSX e renderizava duas âncoras para a mesma tarefa. */}
          {url && (
            <a className="occ-link" href={url} target="_blank" rel="noopener noreferrer">
              {issueId ? `Ver tarefa #${issueId}` : "Abrir no Redmine"}
              <Icon name="external-link" strokeWidth={2.5} />
            </a>
          )}
        </div>
      )}
    </div>
  );
}

export default OccurrenceItem;
